import React, { useEffect, useState } from 'react'
import ModalForm from '../../../components/modalComponents/ModalForm';
import SpinnerLoading from '../../../components/pageComponents/SpinnerLoading';
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import VerRequerimiento from '../../gestionRequerimientos/modales/VerRequerimiento';
import { useGetRequest } from '../../../hooks/useGetRequest/useGetRequest';
import { getConvocatoriaAPI } from '../../../consumers/backendApisUrls';
import RecapField from '../components/RecapField';

const DetalleConvocatoriaModal = ({ toggleModal, id }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [detalle, setDetalle] = useState(null);
    const [modalVacante, setModalVacante] = useState({ isEnable: false });
    const [executeGet] = useGetRequest();

    const formatearFecha = (value) => {
        if (!value) return null;
        const d = new Date(value);
        if (isNaN(d.getTime())) return value;
        return d.toLocaleDateString("es-PE") + " " + d.toLocaleTimeString("es-PE", { hour: "2-digit", minute: "2-digit" });
    };

    const init = async () => {
        setIsLoading(true);
        try {
            const api = getConvocatoriaAPI(id);
            await executeGet(api).then((res) => setDetalle(res?.data ?? null));
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (isLoading) return <SpinnerLoading />;

    // Si la consulta falló, `detalle` queda en null. No se puede devolver otro
    // <SpinnerLoading /> a secas: fuera de ModalForm no se renderiza la cabecera
    // con la "x", y el modal se quedaba trabado sin forma de cerrarlo.
    if (!detalle) {
        return (
            <ModalForm onSubmit={(e) => e.preventDefault()} titulo="Detalle de la convocatoria"
                showModal={toggleModal} width="900px" hasSaveButton={false}>
                <p className="text-center text-muted mb-0">
                    No se pudo cargar el detalle de la convocatoria.
                </p>
            </ModalForm>
        )
    }

    const {
        IdConvocatoria, NombreConvocatoria, TipoProceso, TipoModalidad, FechaHoraInicio, FechaHoraFin,
        NombreEmpleadoResponsable, DesEstado, DesCargo, NroPostulantes, IdsRegiones, IdsSedes, DesRegiones,
        DesSedes, Lineamientos,
        // Datos del postulante (TP_Postulante): solo vienen con valor cuando la
        // convocatoria es Individual — ver CONVOCATORIA_DATOS_POSTULANTE_INDIVIDUAL
        // en intranet-puestos-backend (24/09/2026).
        NombreEmpleado, DesSedeDestino, IdRequerimientoPersonal, DesCargoPromocion,
        NuevoSueldo, Comentario, DesEspecialidadMatriz,
    } = detalle;

    const esIndividual = TipoModalidad === 'I';
    const esPromocion = TipoProceso === 'P';

    return (
        <ModalForm onSubmit={(e) => e.preventDefault()} titulo="Detalle de la convocatoria"
            showModal={toggleModal} width="900px" hasSaveButton={false}>
            <ModalEnabled modalEnabled={modalVacante} setModalEnabled={setModalVacante} refreshPage={() => { }} />

            <div className="displayFlexWrap" style={{ gap: "16px" }}>
                <RecapField label="Nombre de la convocatoria" value={NombreConvocatoria} />
                <RecapField label="Tipo de proceso" value={TipoProceso === 'T' ? 'Traslado' : TipoProceso === 'P' ? 'Promoción' : TipoProceso} />
                <RecapField label="Modalidad" value={TipoModalidad === 'M' ? 'Masivo' : esIndividual ? 'Individual' : TipoModalidad} />
                <RecapField label="Fecha inicio" value={formatearFecha(FechaHoraInicio)} />
                <RecapField label="Fecha término" value={formatearFecha(FechaHoraFin)} />
                <RecapField label="Responsable" value={NombreEmpleadoResponsable} />
                <RecapField label="Estado" value={DesEstado} />
                {!esIndividual && <RecapField label="Cargo (Masivo)" value={DesCargo} />}
                {!esIndividual && <RecapField label="Nro. de postulantes" value={NroPostulantes ?? 0} />}
                {/* IdsRegiones/IdsSedes son un CSV de ids ("6,23,53"). El lambda ya
                    devuelve los nombres resueltos; se cae a los ids solo por si esta
                    pantalla corre contra un lambda todavia sin desplegar. */}
                {!esIndividual && <RecapField label="Regiones" value={DesRegiones ?? IdsRegiones ?? "-"} />}
                {!esIndividual && <RecapField label="Sedes" value={DesSedes ?? IdsSedes ?? "-"} />}
                <RecapField label="Código" value={IdConvocatoria} />
            </div>

            {/* Datos del postulante (24/09/2026): solo aplica a Individual — Masivo
                puede tener 0..N postulantes, no uno solo que mostrar aca (para eso
                esta "Ver Postulantes"). */}
            {esIndividual && (
                <>
                    <hr />
                    <label className="modal-label d-flex" style={{ fontWeight: "bold" }}>
                        Datos del colaborador asignado
                    </label>
                    <div className="displayFlexWrap" style={{ gap: "16px" }}>
                        <RecapField label="Colaborador" value={NombreEmpleado} />
                        <RecapField label="Especialidad (Matriz)" value={DesEspecialidadMatriz} />
                        <RecapField label="Sede destino" value={DesSedeDestino} />
                        {esPromocion && <RecapField label="Cargo destino" value={DesCargoPromocion} />}
                        {esPromocion && <RecapField label="Nuevo sueldo" value={NuevoSueldo != null ? `S/ ${NuevoSueldo}` : null} />}
                        <div style={{ minWidth: "150px" }}>
                            <div className="modal-label" style={{ marginBottom: "2px" }}>Vacante destino</div>
                            {IdRequerimientoPersonal
                                ? <button type="button" className="btn btn-link p-0"
                                    onClick={() => setModalVacante({ isEnable: true, component: VerRequerimiento, data: { id: IdRequerimientoPersonal } })}>
                                    Ver vacante (#{IdRequerimientoPersonal})
                                </button>
                                : <div className="black-color font-weight-bold">-</div>
                            }
                        </div>
                    </div>
                    {Comentario && (
                        <div className="mt-2">
                            <div className="modal-label" style={{ marginBottom: "2px" }}>Comentarios</div>
                            <div className="black-color">{Comentario}</div>
                        </div>
                    )}
                </>
            )}

            {/* CA-06: los lineamientos se guardan con formato (HTML), así que van
                a todo el ancho y no como RecapField de una línea. */}
            {Lineamientos && (
                <div className="mt-3">
                    <label className="modal-label d-flex">Lineamientos</label>
                    <div style={{ maxHeight: "16rem", overflowY: "auto", padding: "8px 12px", border: "1px solid #ced4da", borderRadius: "4px" }}
                        dangerouslySetInnerHTML={{ __html: Lineamientos }} />
                </div>
            )}
        </ModalForm>
    )
}

export default DetalleConvocatoriaModal
